import { render, staticRenderFns } from "./HeaderNavigationSubcategories.vue?vue&type=template&id=1dd333f5&scoped=true"
import script from "./HeaderNavigationSubcategories.vue?vue&type=script&lang=ts"
export * from "./HeaderNavigationSubcategories.vue?vue&type=script&lang=ts"
import style0 from "./HeaderNavigationSubcategories.vue?vue&type=style&index=0&id=1dd333f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd333f5",
  null
  
)

export default component.exports